exports.NumberFormat = class NumberFormat

  @format = (number) ->
    new String(number).replace(/^(-?)\d*\.?/, (match) -> match.replace(/(\d)(?=(?!\.)(\d\d\d)+(?!\d))/g, "$1,")).toString()

  @formatWithUnit = (number, significantDigits = 0, precision = 0) ->
    num = parseInt(number, 10)
    numString = num.toString()
    if num < 1000
      return "#{num}"
    else if( num >= 1000 and num <= 999999)
      num = parseInt(num / 1000, 10).toString()
      precision = Math.max(0, precision, significantDigits - num.length)
      if precision
        decimalDigits = numString.substr(num.length, precision)
        if decimalDigits
          num += ".#{decimalDigits}"
      num += "K"
    else if (num >= 1000000 )
      num = parseInt(num / 1000000, 10).toString()
      precision = Math.max(0, precision, significantDigits - num.length)
      if precision
        decimalDigits = numString.substr(num.length, precision)
        if decimalDigits
          num += ".#{decimalDigits}"
      num += "MM"
    num

  @bytesToSize = (bytes, precision=0) ->
    kilobyte = 1024
    megabyte = kilobyte * 1024
    gigabyte = megabyte * 1024
    terabyte = gigabyte * 1024
    if (bytes >= 0) and (bytes < kilobyte)
      "#{bytes.toFixed(precision)} B"
    else if (bytes >= kilobyte) and (bytes < megabyte)
      "#{(bytes / kilobyte).toFixed(precision)} KB"
    else if (bytes >= megabyte) and (bytes < gigabyte)
      "#{(bytes / megabyte).toFixed(precision)} MB"
    else if (bytes >= gigabyte) and (bytes < terabyte)
      "#{(bytes / gigabyte).toFixed(precision)} GB"
    else if bytes >= terabyte
      "#{(bytes / terabyte).toFixed(precision)} TB"
    else
      "#{bytes.toFixed(precision)} B"

  @formatFixedFloat = (number, precision = 1, significantDigits = 0) ->
    num = parseInt(number, 10)
    precision = Math.max(0, precision, significantDigits - num.toString().length)
    Number(number).toFixed(precision)

  ###
  # floor() returns the floor of a number
  # based on the decimal number passed as the second argument
  #
  # @param <Number> number
  # @param <Number> decimal between 0 and 1; defaults to 1
  # @return <Number> floor
  ###
  @floor = (number, decimal=1) ->
    number = parseFloat(number)
    decimal = Math.min(1, Math.max(0, decimal))
    Math.floor(number) + Math.min(1, Math.floor(Math.floor((number - Math.floor(number))*100)/(decimal*100))*decimal)

  ###
  # ceil() returns the ceiling of a number
  # based on the decimal number passed as the second argument
  #
  # @param <Number> number
  # @param <Number> decimal between 0 and 1; defaults to 1
  # @return <Number> ceil
  ###
  @ceil = (number, decimal=1) ->
    number = parseFloat(number)
    decimal = Math.min(1, Math.max(0, decimal))
    Math.floor(number) + Math.min(1, Math.ceil(Math.floor((number - Math.floor(number))*100)/(decimal*100))*decimal)

  # Parse a number to percentage
  @parseNumberToPercentage = (number, total, offset=0) ->
    Math.round((number - offset) / (total - offset) * 100)

  ###
  # formatToClosestWhole() returns a rounded formated number
  # based on the right digit after the most left comma
  #
  # @param <Number> number
  # @return <Number> formatToClosestWhole
  ###
  @formatToClosestWhole = (number) ->
    num = parseInt(number, 10)
    extractDigit = (number, digitLocation) ->
      number = number + ''
      return parseInt(number[number.length - digitLocation], 10)

    if num < 1000
     return num + ''
    else if 1000 <= num <= 999999
      shortNumber = parseInt(num / 1000, 10)
      shortNumber++ if extractDigit(num, 3) >= 5
      return shortNumber + 'K'
    else if (number >= 1000000 )
      shortNumber = parseInt(number / 1000000, 10)
      shortNumber++ if extractDigit(num, 6) >= 5
      return shortNumber + 'MM'

    return num + ''



// WEBPACK FOOTER //
// ../~/webapps-frontend-components/src/main/shared/utils/NumberFormat.coffee